module.exports = __webpack_public_path__ + "static/media/creator-awards-logo-holding.6253ab19.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/creator-awards-logo-holding.png
// module id = 334
// module chunks = 0